import { gql } from "apollo-angular";
import { CBF } from "./content-block"
import { LINK_FIELDS } from "./link";
import { TF } from "./tuition-and-fee-finder";
import { ME } from "./military-estimator";
import { PORTFOLIO_CALCULATOR_FORM } from "./pc-form";
import { SIF_THANK_YOU } from "./sif-thank-you";

export const BH = gql`
  fragment BH on BigHero {
    sys {
      id
    }
    isPzd
    title
    backgroundColor {
      color
    }
    configuration
    cb:content {
      ... CBF
    }
    textPositionHorizontal
    textPositionVertical
    backgroundImage {
      url
      description
      sys {
        id
      }
    }
    imageOverlay
    imageOverlayText
    imagePositionHorizontal
    imagePositionVertical
    hideMobileImage
    youTubeVideoLink
    backgroundForm {
      color
    }
    form {
      ... on HeroProgramFinder {
        header
        hTag
        content
        buttonText
      }
      ... on SifThankYouMessage {
        ... SIF_THANK_YOU
      }
      ... on SifGenericForm {
        sys {
          id
        }
      }
      ... on TuitionFeeFinder {
        sys {
          id
        }
      }
      ... on MilitaryEstimator {
        ... ME
      }
      ... on PortfolioCalculatorForm {
         sys {
          id
        }
      }
    }
  }
  ${SIF_THANK_YOU}
  ${ME}
 ${CBF}
 ${LINK_FIELDS}`;
